export default {
  "en-us": {
    "1": {
      id: 1,
      question: "When you trade a share CFD, which statement is true?",
      options: {
        a: "You have the right to attend the annual general meeting.",
        b: "You take on less risk than trading physical shares.",
        c: "You don't own the underlying stock directly in your name.",
        d: "You have share voting rights.",
      },
    },
    "2": {
      id: 2,
      question: "What best describes CFD markets?",
      options: {
        a: "They are traded over-the-counter (OTC) between you and BCR.",
        b: "They are traded on the Australian Securities Exchange (ASX).",
        c: "It depends on demand.",
        d: "They are traded on the NASDAQ.",
      },
    },
    "3": {
      id: 3,
      question:
        "Trading in CFDs generally occurs via an online trading platform. The online trading platform allows you to:",
      options: {
        a: "Open and close positions.",
        b: "Actively monitor your trading account.",
        c: "Obtain price indications.",
        d: "All of the above.",
      },
    },
    "4": {
      id: 4,
      question:
        "You have a current account balance of $50,000, account equity of $40,000, and only one open position in AUDUSD with a margin requirement of $30,000. The margin call level is 100%. Under which of the following circumstances will you receive a margin call?",
      options: {
        a: "When your account balance is lower than $40,000.",
        b: "When your account balance is lower than $50,000.",
        c: "When your account equity is lower than $30,000.",
        d: "When your account equity is $0.",
      },
    },
    "5": {
      id: 5,
      question: "What does the term “equity” refer to?",
      options: {
        a: "Equity is your account balance plus the floating profit (or loss) of all your open positions.",
        b: "Equity is the TOTAL amount of margin currently in use to maintain all open positions.",
        c: "Equity is the gap between the bid and the ask price.",
        d: "Equity is the total margin required to hold all current open positions.",
      },
    },
    "6": {
      id: 6,
      question: "What does a “stop loss” do?",
      options: {
        a: "Guarantees you will not lose money.",
        b: "Pays you a bonus if it gets activated.",
        c: "Limits your loss by entering into a trade at the next available price.",
        d: "It refunds all of your losses.",
      },
    },
    "7": {
      id: 7,
      question: "Why would you use a stop loss?",
      options: {
        a: "To open a new position.",
        b: "To limit your loss on a trade.",
        c: "To make maximum profit on a trade.",
      },
    },
    "8": {
      id: 8,
      question: "What is a stop loss order when trading CFDs?",
      options: {
        a: "An order placed to automatically sell an asset when its price reaches a certain level.",
        b: "An order to buy an asset when its price increases by a certain percentage.",
        c: "An order to adjust the leverage on an open position.",
        d: "An order to close a profitable position once a specific profit target is reached.",
      },
    },
    "9": {
      id: 9,
      question: "What are the risks of trading leveraged products?",
      options: {
        a: "You could potentially lose all of the money that you deposited in your account.",
        b: "Due to the leverage element, you may suffer losses normally associated with a much larger investment.",
        c: "Highly leveraged transactions are subject to significant changes in value as a result of relatively small changes in the value or level of an underlying asset ",
        d: "All of the above.",
      },
    },
    "10": {
      id: 10,
      question: "The following is true with regard to leverage:",
      options: {
        a: "Leverage can be used with various financial instruments to increase potential returns.",
        b: "Leverage can be implemented via CFDs and margin FX contracts.",
        c: "Leverage magnifies both gains and losses.",
        d: "All of the above.",
      },
    },
    "11": {
      id: 11,
      question:
        "When you deposit $7,000 and trade on an underlying instrument with leverage of 1:5, what is the maximum leverage amount you can trade with?",
      options: {
        a: "$35,000",
        b: "$12,000",
        c: "$7,000",
        d: "$5,000",
      },
    },
    "12": {
      id: 12,
      question:
        "When you deposit $20,000 and trade on an underlying instrument with a leverage of 1:20, what is the maximum leverage amount you can trade with?",
      options: {
        a: "$4,000,000",
        b: "$400,000",
        c: "$40,000",
        d: "$400",
      },
    },
    "13": {
      id: 13,
      question: "How does using leverage impact your trading account?",
      options: {
        a: "It increases both profit potential and potential losses.",
        b: "It guarantees higher profits.",
        c: "It reduces your margin requirements but eliminates risk.",
        d: "It ensures you never experience a margin call.",
      },
    },
    "14": {
      id: 14,
      question:
        "You hold a 3oz. long(buy) position in Australian dollar spot gold, and the market mid-price is currently A$2,200. If the margin requirement for this trade is 5%, what is the total margin requirement for this trade?",
      options: {
        a: "A$2,200",
        b: "A$330",
        c: "A$3,300",
        d: "A$220 ",
      },
    },
    "15": {
      id: 15,
      question: "What is a margin call?",
      options: {
        a: "A notice to deposit additional funds into your trading account to cover potential losses.",
        b: "A requirement for you to close out a profitable position to take out funds.",
        c: "A warning that your account balance is at risk of being closed due to higher profits.",
        d: "A notification that you have reached your maximum allowable leverage.",
      },
    },
    "16": {
      id: 16,
      question: "If you do not meet a margin call, we are permitted to:",
      options: {
        a: "Automatically close out your open positions without notice to you.",
        b: "Open new positions on your account.",
        c: "Close out your open positions once we have given 4 days’ notice to you.",
        d: "Open a new trading account for you.",
      },
    },
    "17": {
      id: 17,
      question:
        "You hold a 5oz. long(buy) position in Australian dollar spot silver, and the market mid-price is currently A$25.00 per ounce. If the margin requirement for this trade is 10%, what is the total margin requirement for this trade?",
      options: {
        a: "A$12.50",
        b: "A$125.00",
        c: "A$250.00",
        d: "A$1,250.00",
      },
    },
    "18": {
      id: 18,
      question:
        "You open a $10,000 position with $2,000 margin (5:1 leverage). If the market moves 10% against you, what percentage of your margin would you lose?",
      options: {
        a: "5%",
        b: "10%",
        c: "100%",
        d: "50%",
      },
    },
    "19": {
      id: 19,
      question: "What is market volatility?",
      options: {
        a: "When there is little or no movement in price over a period of time.",
        b: "When there are large movements in price over a short period of time.",
        c: "A measure of how much profit you will make on a trade.",
      },
    },
    "20": {
      id: 20,
      question:
        "OTC derivative markets are volatile. Which statement is incorrect?",
      options: {
        a: "In a volatile market prices can rapidly fluctuate.",
        b: "Volatility can be the result of unforeseen events or changes in market conditions.",
        c: "Because market prices can rapidly fluctuate, you should closely monitor your open positions at all times.",
        d: "Volatility means that OTC derivative trades are less risk.",
      },
    },
    "21": {
      id: 21,
      question:
        "When trading share CFDs, which factor may increase volatility in the relevant underlying share price?",
      options: {
        a: "A company's earnings report release.",
        b: "A change in the CFD broker’s margin requirements.",
        c: "A CFD trader executing a large single trade.",
        d: "A CFD trader using stop loss orders in an account.",
      },
    },
    "22": {
      id: 22,
      question: "Which of the following best describes “gapping”?",
      options: {
        a: "Gapping is the break between prices on a chart that occurs when the price of a market makes a sharp move up or down with no trading occurring between those prices.",
        b: "The change in your account balance after making a large deposit or withdrawal.",
        c: "The “gap” is the difference between the buy and the sell price .",
        d: "The “gap” is the difference between the Market Open and Market Close price.",
      },
    },
    "23": {
      id: 23,
      question: "Which of the following best describes “gapping”?",
      options: {
        a: "The process of increasing leverage on an open position to maximise profits.",
        b: "Where the underlying market price moves in large and discrete steps and skips one or more price points, which may prevent you from closing your trade at a chosen price limit between two price levels.",
        c: "The automatic closure of a position by a CFDs issuer to prevent further losses.",
        d: "A trading strategy that involves holding positions overnight to take advantage of small price movements.",
      },
    },
    "24": {
      id: 24,
      question: "The following is true with regard to “gapping”",
      options: {
        a: "It occurs where the bid or offer price is significantly lower or higher than the price at which the order is placed.",
        b: "There is no guarantee that a stop loss order will limit your downside risk;",
        c: "You cannot avoid the risk of “gapping”.",
        d: "All of the above.",
      },
    },
    "25": {
      id: 25,
      question:
        "Who is ultimately responsible for monitoring and managing your trading account?",
      options: {
        a: "BCR’s risk team.",
        b: "It is my responsibility to monitor and manage my trading account.",
        c: "My trading account does not require management or monitoring.",
        d: "My financial advisor should monitor my trading account.",
      },
    },
    "26": {
      id: 26,
      question: "Which statement is incorrect?",
      options: {
        a: "I am responsible for closely monitoring my open positions at all times.",
        b: "I am required to monitor my margin requirements at all times.",
        c: "I am not responsible for closely monitoring my open positions at all times.",
        d: "I am responsible for providing and maintaining the means by which I access the online trading platform.",
      },
    },
    "27": {
      id: 27,
      question:
        "If you were intending to open a “short” position in FX, you would be:",
      options: {
        a: "Buying the currency pair in the hope its value will rise.",
        b: "Selling the currency pair in the hope its value will rise.",
        c: "Selling the currency pair in the hope its value will fall.",
        d: "Buying the currency pair in the hope its value will fall.",
      },
    },
    "28": {
      id: 28,
      question: "If you go “long” on a position, this means you:",
      options: {
        a: "expect the price of the underlying asset to rise.",
        b: "expect the price of the underlying thing to decrease.",
        c: "expect the price of the underlying thing to stay the same.",
        d: "expect the price of the underlying thing to fluctuate.",
      },
    },
    "29": {
      id: 29,
      question: "What is a “limit order” in CFD trading?",
      options: {
        a: "An order placed to open or close a trade at a specified price or better.",
        b: "An order to automatically close a position once it reaches a pre-set loss level.",
        c: "A market order that executes at the best available price.",
        d: "An instruction to double the size of an open position.",
      },
    },
    "30": {
      id: 30,
      question: "The following is true with regard to “execution risk”:",
      options: {
        a: "it arises due to a time lag between when you seek to open or close a position and when that position is actually opened or closed.",
        b: "it may result in your position being opened or closed at a lower or higher price than when you sought to open or close the position.",
        c: "it often arises where the market for the underlying instrument is volatile or illiquid.",
        d: "all of the above.",
      },
    },
  },
};
